import { render } from "./TermsService.vue?vue&type=template&id=4704efa0&scoped=true"
import script from "./TermsService.vue?vue&type=script&lang=js"
export * from "./TermsService.vue?vue&type=script&lang=js"

import "./TermsService.vue?vue&type=style&index=0&id=4704efa0&scoped=true&lang=css"

import exportComponent from "/data/sg-h5/panther-h5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4704efa0"]])

export default __exports__